<template>
  <el-submenu :popper-append-to-body="false" v-if="menu.children" :index="menu.menuRoute+''">
    <!-- routeName -->
    <!-- :index="menu.menuRoute+''" -->
    <template slot="title">
      <!-- <i class="`menu.menuIcon`"></i> -->
      <span>{{menu.menuTitle}}</span>
    </template>
    <sub-menu @go="handleGo(item)" v-for="item in menu.children" :key="item.id" :menu="item"></sub-menu>
    <!-- <sub-menu v-for="item in menu.children" :key="item.id" :menu="item"></sub-menu> -->
  </el-submenu>
  <el-menu-item v-else :index="menu.menuRoute+''" @click="saveNavstate(menu.menuRoute, menu.id)">
    <template>
      <!-- <i class="el-icon-location"></i> -->
      <span>{{menu.menuTitle}}</span>
    </template>
  </el-menu-item>
</template>

<script>
import SubMenu from "./SubMenu.vue";

export default {
  name: "sub-menu",
  props: {
    menu: {
      type: Object,
      default: null,
    },
  },

  components: {
    SubMenu,
  },

  methods: {
    handleReg(menuRoute) {
      // 可以改造成使用Vuex 保存面包屑的数据 就不用这样向上派发事件
      // console.log('menuRoute.replace(".", "-")', menuRoute.replace(".", "-"));
      return menuRoute.replace(".", "-");
    },
    handleGo(item) {
      console.log("sub-menu item", item);
      this.$emit("go");
    },
    saveNavstate(activePath, id) {
      // debugger;
      // this.$router.push({ path: activePath });

      window.sessionStorage.setItem("activePath", activePath);
      this.activePath = activePath;
      // 根据activePath 找父级， 拧巴一个数组
      // 无限层级 由 id和parentId 构建的数组 合理，
      let menulist = JSON.parse(window.sessionStorage.getItem("menulist"));
      let obj = this._findParent(id, menulist);
      let list = obj.list;
      let res = obj.res;
      console.log("obj", obj);
      let temp = [];
      res.map((item) => {
        if (item.children && item.children.length > 0) {
          temp.push({ title: item.menuTitle });
        }
      });
      // console.log("temp", temp);
      list = temp.concat(list);
      console.log("after concat", list);
      window.sessionStorage.setItem("breadcrumb-list", JSON.stringify(list));
      this.$emit("go");
    },
    _findParent(_id, menuList) {
      // 需要一个 深度遍历算法，
      let res = [];
      let list = [];
      function map(id, arr) {
        for (let item of arr) {
          res.push(item);
          if (item.children && item.children.length > 0) {
            map(id, item.children);
          } else {
            if (item.id === id) {
              list.push({ title: item.menuTitle });
              res.push(item);
            } else {
              res.pop();
            }
          }
        }
        res.pop();
      }
      map(_id, menuList);
      return { list, res };
    },
  },
};
</script>

<style lang="scss" scoped>
.el-menu--horizontal >>> {
  .el-menu--popup {
    width: auto;
  }
}
.el-menu--horizontal {
  background: blue;
}
</style>


// WEBPACK FOOTER //
// src/views/common/SubMenu.vue